import { Method } from 'axios';
import { APICallV4 } from 'reactApp/api/APICall';

export class RemoveAlbumItemsAPICall extends APICallV4 {
    _method = 'album/elements/remove';
    _type: Method = 'post';
}
